import axios from "axios"

const UseApiService = {
    get: ({ url, params, headers, query }) => {
        const finalParams = query ? { ...params, ...query } : params;
        return axios.get(url, {
            params: finalParams,
            headers,
        });
    },

    post: ({ url, data, params, headers }) => {
        return axios.post(url, data, {
            params,
            headers,
        });
    },

    put: ({ url, data, params, headers }) => {
        return axios.put(url, data, {
            params,
            headers,
        });
    },

    patch: ({ url, data, params, headers }) => {
        return axios.patch(url, data, {
            params,
            headers,
        });
    },

    delete: ({ url, params, headers }) => {
        return axios.delete(url, {
            params,
            headers,
        });
    },
};

export default UseApiService;

 
